import { render, staticRenderFns } from "./women.vue?vue&type=template&id=26dc17a3&"
import script from "./women.vue?vue&type=script&lang=js&"
export * from "./women.vue?vue&type=script&lang=js&"
import style0 from "./women.vue?vue&type=style&index=0&id=26dc17a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieConsent: require('/var/www/jaty-frontend/components/CookieConsent.vue').default,HomeHeader: require('/var/www/jaty-frontend/components/HomeHeader.vue').default,MarketingSubnav: require('/var/www/jaty-frontend/components/marketing/Subnav.vue').default,HomeFooter: require('/var/www/jaty-frontend/components/HomeFooter.vue').default})
